import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import '@scoutgg/ftw/source/services/drag-and-derp'
import '@scoutgg/ftw/source/services/drag-with-image'
import '@scoutgg/ftw/source/atoms/toggle/toggle'
import '@scoutgg/ftw/source/atoms/modal/modal'
import '@scoutgg/ftw/source/atoms/dropdown/dropdown'
import notify from '@scoutgg/ftw/source/services/notification'
import '@scoutgg/ftw/source/atoms/button/button'
import sourceManager from '../../services/source-manager'
import query from '../../services/query'
import pushState from '../../services/state'
import normalize from '../../../helpers/normalize'
import template from './player-sources.jade'
import {Season, Team, PlayerSource, SeasonSource} from '../../models'
import Modal from '@scoutgg/ftw/source/services/modal'
import EditPlayerSource from '../edit-player-source'
import emitter from '@scoutgg/ftw/source/services/emitter'
import config from '@scoutgg/ftw/source/services/config'
import '../seasons'
import { countries, lookup } from 'country-data'
import { enum as genderEnum } from '../../../models/concerns/gender'


function toKey(player) {
  var team = (player.team && player.team.name) || player.team
  if(!team) return
  return [
    normalize(player.firstName),
    normalize(player.lastName),
  ].join('|')
}

function byStuff(a, b) {
  var aTeam = a.teamName || ''
  var bTeam = b.teamName || ''
  return aTeam.localeCompare(bTeam) ||
    ((a.shirt || -1) - (b.shirt || -1)) ||
    (a.lastName || '').localeCompare(b.lastName || '')
}

const mapping = {
  binary: 'BinaryString',
  string: 'BinaryString',
  buffer: 'ArrayBuffer',
  text: 'Text',
  uri: 'DataURL',
}

function load(file, type) {
  type = mapping[type] || ''

  const reader = new FileReader()
  return new Promise((resolve, reject) => {
    reader.onload = e => resolve(e.target.result)
    reader.onerror = e => reject(e.target.error)
    reader['readAs' + type](file)
  })
}

const prices = Symbol('prices')

@Component('sporty')
@Template(template)
@Attribute('season', Season)
@Attribute('source', SeasonSource)
@Attribute('team', Team)
@Attribute('maxSources', Number)
export default class PlayerSources extends HTMLElement {
  attached() {
    this.tab = 0
    this.maxSources = 0
    sourceManager.attached(this, 'player')
    this.reload()
    const q = query()
    this.team = q.team
    this.search = q.search
    this.countries = countries.all.sort((a, b) => a.name.localeCompare(b.name))
    this.genders = genderEnum
    this.update(Season.load({ active: true }))
    window.addEventListener('popstate', ev => {
      this.season = (ev.state && ev.state.season) || this.season
      this.team = (ev.state && ev.state.team) || null
      this.search = (ev.state && ev.state.search) || ''
      this.uncache()
    })
    emitter.on('player:edited', (event) => {
      this.createCustomSource(event.player)
    })
  }

  setFile({files: [file]}) {
    const season = this.season._id

    this.render()

    this.$file = load(file, 'text')
      .then(data => {
        const result = { matches: [], teams: [], players: [], season }

        const teams = {}

        function playerFromRow(result, row) {
          let [uid, firstName, lastName, team, position, shirt, gender, country] = row
            .split(',')
            .map(thing => thing.trim())

          // Make sure gender is valid
          if (gender) {
            switch(gender.toLowerCase()) {
              case 'male':
              case 'men':
              case 'man':
                gender = 'male'
                break
              case 'female':
              case 'women':
              case 'woman':
                gender = 'female'
                break
              default:
                gender = undefined
            }
          }

          // Make sure the country is valid
          if (country) {
            let found =
              lookup.countries({name: country})[0] ||
              lookup.countries({alpha2: country})[0] ||
              lookup.countries({alpha3: country})[0]

             country = found ? found.alpha2 : undefined
          }

          result.players.push({ uid, firstName, lastName, position, team, shirt, gender, country })

          if(!teams[team]) {
            result.teams.push({uid: team, name: teams[team] = team})
          }

          return result
        }

        return data.trim().split('\n').reduce(playerFromRow, result)
      })
  }

  upload() {
    if(!this.$file) return
    return this.$file
      .then(data => {
        return fetch('/api/player-sources/upload', {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            authorization: `Bearer sportyman ${config.token}`,
            'Content-Type': 'application/json',
          },
        })
      })
      .then(() => {
        notify('Sources uploaded', {level: 'success', timeout: 5000})
        return this.reload()
      })
      .catch(err => {
        notify(err.message, {level: 'danger', timeout: 10000})
        console.error(err)
        this.render()
      })
  }

  save() {
    if(this.$isSubmitting) return
    this.$isSubmitting = true
    PlayerSource.post('', {
      season: this.season._id,
      create: this.newPlayers.map(s => s._id),
      unset: this.nonSources.filter(p => p.$changed).map(s => {
        s.$changed = false
        return s._id
      }),
      custom: this.customSources.filter(p => p.$changed).map(s => {
        s.$changed = false
        return {
          player: s.playerId,
          firstName: s.firstName || '',
          lastName: s.lastName || '',
          customName: s.customName || '',
          shirt: s.shirt === '-' ? -1 : (s.shirt === 0 ? s.shirt : ( s.shirt || void 0)),
          overrideTeam: s.overrideTeamId,
          position: s.position || void 0,
          gender: s.gender || void 0,
          country: s.country || void 0,
          status: s.status || void 0,
          uid: s.uid || void 0,
          source: s.source || void 0,
        }
      }),
      pair: this.playerSources
        .filter(s => {
          return s.$changed && s.player &&
            (!this.team || s.teamSource?.team === this.team)
        })
        .map(s => {
          s.$changed = false
          return {
            _id: s._id,
            player: s.playerId,
            priority: s.priority,
          }
        }),
      prices: this.prices.filter(p => p.$changed).map(p => {
        p.$changed = false
        return {
          _id: p._id,
          disabled: p.disabled,
        }
      }),
    })
      .then(() => {
        notify('Sources updated', {level: 'success', timeout: 5000})
        return this.reload()
      })
      .catch(err => {
        notify(err.message, {level: 'danger', timeout: 10000})
        console.error(err)
        this.render()
      })
      .then(() => {
        this.$isSubmitting = false
      })
    this.render()
  }

  async reload() {
    if(!this.season) return
    var params = {
      $reload: true,
      season: this.season._id,
    }
    const data = await PlayerSource.load(params)
    Object.assign(this, data)
    this[prices] = {}
    for(const price of (data.prices || [])) {
      this[prices][price.player] = price
    }
    this.customSources = data.customSources.map(s => {
      return PlayerSource.instance(s._id, s)
    })
    sourceManager.cacheModels(this, 'player')
    this.uncache()
  }

  send(season, type) {
    if(season.$isSubmitting) return
    season.$isSubmtting = true
    season.post(`send-${type}`).then(() => {
      notify(`Sending of ${type} is completed`, {
        level: 'success',
        timeout: 5000,
      })
    }).catch(err => {
      notify(err.message, {level: 'danger', timeout: 1000})
    }).then(() => {
      season.$isSubmitting = false
      this.render()
    })
    this.render()
  }

  seasonChange() {
    this.reload()
  }

  uncache() {
    this.$cached = null
    this.render()
  }

  changeSeason({season}) {
    this.season = season
    this.team = null
    this.reload()
    this.changeState()
  }

  changeSport(sport) {
    this.sport = sport || null
    this.changeState()
    this.render()
  }

  changeTeam(team) {
    this.$cached = null
    this.team = team || null
    if(team === ' <any team>') {
      this.team = null
    }
    this.changeState()
  }

  changeState() {
    pushState({
      team: this.team && this.team._id,
      season: this.season && this.season._id,
    })
  }

  assignNew() {
    this.nonSources.forEach(source => {
      source.$new = true
      this.showScroll = true
    })
    this.render()
  }

  autoAssign() {
    sourceManager.autoAssign({
      attribute: 'player',
      sources: this.playerSources,
      models: this.players,
      seasonSource: this.source,
      hash: toKey,
    })
    this.uncache()
    this.render()
  }

  clear() {
    this.playerSources.forEach(source => {
      this.showScroll = false
      delete source.$new
    })
    this.uncache()
  }

  createCustomSource(player) {
    if(player._id === '-1') return this.createPlayer(player)
    if(!this.overridedPlayer(player)) this.createSource(player)
    this.setCustom(player)
  }

  createSource(player) {
    let customSource = this.seasonSources[0] && this.seasonSources[0].source
    let source = PlayerSource.create({
      source: customSource === 'steamAPI' ? 'steamAPI' : 'custom',
      priority: 0,
      player: player,
    })
    this.customSources.push(source)
    this.customByModel[source.player] = source
  }

  createPlayer(player) {
    fetch('/player-sources', {
      method: 'POST',
      body: JSON.stringify({season: this.season._id, player: player}),
      headers: {
        authorization: `Bearer sportyman ${config.token}`,
        'Content-Type': 'application/json',
      },
    }).then(() => this.reload())
      .then(() => {
        let newPlayer = this.players[this.players.length - 1]
        this.createSource(newPlayer)
        this.setCustom(newPlayer)
      }).catch(err => {
        notify(err.message, {level: 'danger', timeout: 10000})
        console.error(err)
        this.render()
      })
  }

  setCustom(player) {
    let custom = this.customByModel[player]
    Object.assign(custom, player, custom)
    custom.$changed = true
    this.save()
  }

  openModal(player) {
    return Modal(
      EditPlayerSource({ season: this.season, player: player }),
      { hideCloseBtn: true },
    )
  }

  sources(player) {
    return (this.sourcesByModel || {})[player] || []
  }

  updateFilter(e) {
    this.search = e.target.value
    this.uncache()
  }

  setTab(tab) {
    this.tab = tab
    this.render()
  }

  disabledPrice(player) {
    if(!this[prices]) return
    if(this[prices][player] && this[prices][player].disabled) return true
  }

  overridedPlayer(player) {
    if(player?.playerSources.find(s => s.source === 'custom')) return true
    return false
  }

  get sortedPlayers() {
    var players = this.players
    var maxSources = this.maxSources === (this.seasonSources || [].length)
      ? Infinity
      : this.maxSources
    return this.$cached || (this.$cached = sourceManager.sortedModels({
      attribute: 'player',
      search: this.search,
      sourceCount: maxSources,
      models: this.team
        ? players.filter(p => !this.team || p.team === this.team)
        : players,
      sources: this.playerSources,
      sort: byStuff,
      match(player, search) {
        // eslint-disable-next-line eqeqeq
        return player.shirt == search || // intentional double equals
          ~normalize(player.firstName).indexOf(search) ||
          ~normalize(player.lastName).indexOf(search) ||
          ~normalize(player.customName).indexOf(search) ||
          ~normalize(player.position).indexOf(search) ||
          ~normalize(player.team && player.team.name).indexOf(search)
      },
    }))
  }
  get newPlayers() {
    var team = this.team
    return (this.playerSources || [])
      .filter(s => {
        return !s.player && s.$new &&
          (!team || s.teamSource?.team === team)
      })
      .sort(byStuff)
  }
  get nonSources() {
    var ret = sourceManager.nonSources({
      attribute: 'player',
      sources: this.playerSources,
      seasonSource: this.source,
      gender: this.gender,
      country: this.country
    }).sort(byStuff)
    if(this.team) ret = ret.filter(s => s.teamSource?.team === this.team)
    return ret
  }
  get sortedTeams() {
    return (this.teams || [])
      .filter(t => !t.notAvailable)
      .sort((a, b) => {
        return (a.name || '').localeCompare(b.name)
      })
  }
  get positions() {
    return this.season.positions()
  }
  get filteredPlayers() {
    let players = this.sortedPlayers
    if(players) {
      if(this.tab === 1 && this[prices]) {
        players = players.filter(player => {
          return (this[prices][player] && this[prices][player].disabled)
        })
      }
      return players
    }
  }
  get activeSeasons() {
    const active = this.seasons.filter((s) => s.active)
    return Array.from(new Set(active.map(season => season.sport))).sort()
  }

  get downloadCsvPath() {
    return this.season && `/players/${this.season}.csv`
  }
}
